import { createAsyncThunk } from '@reduxjs/toolkit';
import { BILLING_ROUTES } from '@custom/Utils/constants/apiUrls';

export interface SuccessResponse {
  status: string;
  data?: any;
  msg?: string;
}

export interface ErrorResponse {
  status: string;
  msg: string;
}

export type BillingResponse = SuccessResponse | ErrorResponse;

const getBillingGeneralSettings = createAsyncThunk<BillingResponse, void, { rejectValue: ErrorResponse }>(
  'getBillingGeneralSettings',
  async (_, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const hospitalId = sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');
      const url = BILLING_ROUTES.GENERAL_SETTINGS.getGeneralSettings;
      const response = await fetch(`${url}?hospitalId=${hospitalId}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      const data: BillingResponse = await response.json();
      if (!response.ok) {
        return rejectWithValue(data as ErrorResponse);
      }
      return data as BillingResponse;
    } catch (error) {
      return rejectWithValue({ status: 'error', msg: error.message } as ErrorResponse);
    }
  }
);

export default getBillingGeneralSettings;
